import EventBus from '@/event-bus';
import _Singleton, { deferredSingletonExport } from '@/tools/singleton';
import createStorage from '@/storage';
const Store = createStorage({ name: 'favorites_products' });
import domReady from '@/tools/domReady';
import _findIndex from 'lodash/findIndex';
import _now from 'lodash/now';
import Shop from '@/shop';
import ajax from '@/ajax/favorites';

/**
 * Избранные товары
 * @class
 */
let FavoritesProducts = function (options) {
  options = options || {};

  let self = this;

  self._currency_code = Shop.config.config.currency_code
  self.products = [];
  self.maxItems = options.maxItems || 20;

  // Обновляемся
  domReady(function () {
    let withFavorites = document.querySelector('[data-ui-favorites-add], [data-ui-favorites-delete], [data-ui-favorites-clear], [data-ui-favorites-trigger], [data-ui-favorites-counter], [data-ui-favorites-counter-btn]') || (window.location.pathname == "/favorites");
    if (withFavorites) {
      self._update();
    }
  });
};

/**
* Убираем работу с ajax в отдельный метод
* @method
*
* @param {string}  - задача
* @param {Object} task- товар
*/
FavoritesProducts.prototype._doAjax = function (methodName, task) {
  let self = this;

  ajax[methodName](task.item)
  .done(function (response) {
    self.products = response.products || [];
    self._events(task);
  })
  .fail(function (response) {
    console.warn('fail: ', response);
  })
  .always(function () {
    self._always(task);
  });
};

/**
 * Добавляем товар
 * @method
 *
 * @param {Object} task - задача
 * @param {number} task.item - id товара, добавляемого в избранное
 *
 * @fires before:insales:favorites_products
 * @fires overload:insales:favorites_products
 * @fires in_list:insales:favorites_products
 * @fires add_item:insales:favorites_products
 * @fires always:insales:favorites_products
 *
 * @example
 * FavoritesProducts.add({ item: 123456 });
 */
FavoritesProducts.prototype.add = function (task) {
  let self = this;

  task.item = parseInt(task.item);
  task.method = 'add_item';

  // если достигли максимального кол-ва товаров
  // кидаем остановку
  if (self.products.length >= self.maxItems) {
    task.method = 'overload';
    self._events(task);
    self._always(task);

    return;
  }
  else if (_findIndex(self.products, task.item) != -1) {
    task.method = 'in_list';
    self._events(task);
    self._always(task);

    return;
  }
  self._before(task);
  self._doAjax('add', task);
};

/**
* Удаляем товар из избранного
* @method
*
* @param {Object} task - задача
* @param {number} task.item - id товара, добавляемого в избранное
*
* @fires before:insales:favorites_products
* @fires remove_item:insales:favorites_products
* @fires update_items:insales:favorites_products
* @fires always:insales:favorites_products
*
* @example
* FavoritesProducts.remove({item: 123456});
*/
FavoritesProducts.prototype.remove = function (task) {
  let self = this;

  task.item = parseInt(task.item);
  task.method = 'remove_item';

  self._before(task);
  self._doAjax('remove', task);
};

/**
* Очищаем избранное
* @method
*
* @fires before:insales:favorites_products
* @fires update_items:insales:favorites_products
* @fires always:insales:favorites_products
*
* @example
* FavoritesProducts.clear();
*/
FavoritesProducts.prototype.clear = function () {
  let self = this;
  let task = { item: [] };

  task.method = 'clear';

  self._before(task);
  self._doAjax('clear', task);
};

/**
 * Обновляем состояние избранного
 * @method
 *
 * @fires before:insales:favorites_products
 * @fires update_items:insales:favorites_products
 * @fires always:insales:favorites_products
 *
 * @example
 * FavoritesProducts.update();
 */
FavoritesProducts.prototype.update = function () {
  let self = this;

  self._update({ method: 'update_items' });
};

/**
 * Получение текущего состояния Сравнения
 * @method
 *
 * @return {Object} Объект, описывающий состояние и настройки избранного
 *
 * @example
 * FavoritesProducts.getFavoritesProducts();
 */
FavoritesProducts.prototype.getFavoritesProducts = function () {
  let self = this;

  return self;
};

/**
 * Получение актуальной инфы с сервера
 * @method
 * @private
 *
 * @param {Object} task - задача
 * @param {string} task.method - название метода. Объязательно. Иначе мы делаем инициализацию сущности.
 */
FavoritesProducts.prototype._update = function (task) {
  let self = this;
  let isClientAccountPage = window.location.href.includes('/client_account/') || document.referrer.includes('/client_account/');

  task = task || {};
  task.method = task.method || 'init';
  if (task.method == 'init' || task.method == 'update_items') {
    self._before(task);
  }

  Store.getItem('favorites_products-' + self._currency_code)
    .then(function (favoritesProductsAtStore) {
      if (favoritesProductsAtStore && favoritesProductsAtStore.updated_at) {
        let favoritePage = window.location.pathname == '/favorites';
        let favoritesProducts = favoritesProductsAtStore.products;
        let liveTime = _now() - favoritesProductsAtStore.updated_at;
        if (liveTime < 15000 && !favoritePage && !isClientAccountPage) {
          self._events(task, favoritesProducts, true);

          return;
        }else{
          self._doAjax('get', task);
        }
      } else {
        if (task.method == 'init') {
          if (document.readyState == 'complete') {
            self._doAjax('get', task);
          }else{
            window.addEventListener('load', function() {
              self._doAjax('get', task);
            });
          }
        } else {
          self._doAjax('get', task);
        }
      }
    });
};

/**
 * Вызов событий
 * @method
 * @private
 *
 * @param {Object} task - задача
 * @param {string} task.method - назание действия, которое пытаемся сделать
 * @param {boolean} fromInit - проверка, актуальны ли данные в избранном или нужно обновлять
 */
FavoritesProducts.prototype._events = function (task, products, fromInit) {
  let self = this;
  let data = self;

  // ставим новые данные в кеш если не актуален
  if (!fromInit) {
    Store.setItem('favorites_products-' + self._currency_code, {
      products: data.products || [],
      updated_at: _now()
    });
  }
  data.action = task;
  if (products) {
    data.products = products;
  }
  EventBus.publish(task.method + ':insales:favorites_products', {
    products: data.products || [],
    action: data.action
  });

  if (data.action.method != 'update_items' && data.action.method != 'overload') {
    EventBus.publish('update_items:insales:favorites_products', {
      products: data.products || [],
      action: data.action
    });
  }
};

/**
 * Событие ПЕРЕД действием
 * @method
 * @private
 */
FavoritesProducts.prototype._before = function (task) {
  EventBus.publish('before:insales:favorites_products', task);
};

/**
 * Мы закончили что-то делать в избранном
 * @method
 * @private
 */
FavoritesProducts.prototype._always = function (task) {
  EventBus.publish('always:insales:favorites_products', task);
};

export default deferredSingletonExport(_Singleton(FavoritesProducts), FavoritesProducts);
